<!-- Dashboard.vue -->
<template>
  <div v-if="Object.keys(dataDashboard).length > 0">
    <div class="d-flex align-items-center justify-content-end mb-1">
      <b-button :variant="linkCopied ? 'success' : 'outline-primary'" size="sm" @click="copyReferenceLink"
        class="d-flex align-items-center justify-content-center">
        <feather-icon icon="CopyIcon" size="18" class="mr-1" />
        <span>
          {{ linkCopied ? 'Link copiado!' : 'Copiar link de convite' }}
        </span>
      </b-button>
    </div>
    <b-row>
      <b-col md="6" xl="3">
        <b-card :title="$t('Bônus das indicações diretas')">
          <!-- Blocos de bônus diretos -->
          <bonus-card :nivel="1" :bonus="dataDashboard.dataDirectReferences.totalBonusDirect"
            :descricao="$t('Recebido dos afiliados diretos')" />
          <bonus-card :nivel="2" :bonus="dataDashboard.dataDirectReferences.totalReferences"
            :descricao="$t('Afiliados diretos')" :isNumeric="true" />
          <bonus-card :nivel="3" :bonus="dataDashboard.dataDirectReferences.activeReferences"
            :descricao="$t('Afiliados diretos ativos')" :isNumeric="true" />
        </b-card>
      </b-col>
      <b-col md="6" xl="3">
        <b-card :title="$t('Rede unilevel do 2º ao 3º nível')">
          <!-- Uso do componente BonusCard para níveis 2 a 10 -->
          <bonus-card v-for="nivel in 2" :key="nivel" :nivel="nivel + 1"
            :bonus="dataDashboard.dataUnilevelReferences[`totalBonusLevel${nivel + 1}`]"
            :descricao="$t(`Recebido das indicações de ${nivel + 1}º nível`)" />
        </b-card>
      </b-col>
      <b-col xl="6">
        <bonus-historical />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BonusHistorical from "./BonusHistorical.vue";
import BonusCard from "./BonusCard.vue";
import copy from "copy-text-to-clipboard";
import { mapGetters } from "vuex";

export default {
  components: {
    BonusHistorical,
    BonusCard,
  },
  data() {
    return {
      linkCopied: false,
      dataDashboard: {},
      referenceLink: "",
    };
  },
  computed: {
    ...mapGetters(["returnUser", "returnLocale"]),
  },
  mounted() {
    this.referenceLink = `${process.env.VUE_APP_FRONT_URL}/ref/${this.returnUser._id}`;
    this.$store.dispatch("affiliatesDashboard").then((resp) => {
      this.dataDashboard = resp;
    });
  },
  methods: {
    copyReferenceLink() {
      copy(this.referenceLink);
      this.linkCopied = true;
      setTimeout(() => {
        this.linkCopied = false;
      }, 2000);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.limitString {
  /* Sem restrições específicas para desktop */
}

/* Estilo para dispositivos móveis */
@media (max-width: 768px) {
  .limitString {
    white-space: nowrap;
    max-width: 16rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.icon-positive {
  color: #26C86E;
  font-size: 1.3rem;
}

.icon-negative {
  color: #ED6B6C;
  font-size: 1.3rem;
}
</style>
